import { render, staticRenderFns } from "./WorkflowHost.vue?vue&type=template&id=244381e2&"
import script from "./WorkflowHost.vue?vue&type=script&lang=js&"
export * from "./WorkflowHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports